import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './context/AuthContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <BrowserRouter> {/* Move BrowserRouter to wrap AuthProvider and App */}
    <AuthProvider>
      <App />
    </AuthProvider>
  </BrowserRouter>
);
